<script>
	import { ModalPreview, Navbar, Hero, ButtonAddElement, FieldTitle, FieldDate, FieldText, FieldImage, ContainerTemplate } from "./components";
	import { pkgBrief, outputFileName, modalIsActive } from "./components/store.js";
	import { onMount } from "svelte";

	let currentDate = new Date();
	$outputFileName = currentDate.getDate() + "-" + (currentDate.getMonth()+1)  + "-" + currentDate.getFullYear() + "-"  + currentDate.getHours() + "-" + currentDate.getMinutes();

	function previewHandler() {
		$modalIsActive = true;
	};

	function pdfHandler(){

	};

	onMount(async () => {
		'use strict';
		document.addEventListener('DOMContentLoaded', function () {
			var $dropdowns = getAll('.dropdown:not(.is-hoverable)');

			if ($dropdowns.length > 0) {
				$dropdowns.forEach(function ($el) {
					$el.addEventListener('click', function (event) {
						event.stopPropagation();
						$el.classList.toggle('is-active');
					});
				});

				document.addEventListener('click', function (event) {
					closeDropdowns();
				});
			}

			function closeDropdowns() {
				$dropdowns.forEach(function ($el) {
					$el.classList.remove('is-active');
				});
			}

			document.addEventListener('keydown', function (event) {
				var e = event || window.event;
				if (e.keyCode === 27) {
					closeDropdowns();
				}
			});

			function getAll(selector) {
				return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
			}
		});
	});
</script>

<main>
	<Navbar />
	<Hero />

	<section class="section">
		<ContainerTemplate />

		<div class="container box content has-background-grey-dark has-text-white">
			<h1 class="has-text-white">Form Brief</h1>

			{#each $pkgBrief as brief, i}
			{#if brief.type == 0}
			<FieldTitle index={i} />
			{:else if brief.type == 1}
			<FieldText index={i} />
			{:else if brief.type == 2}
			<FieldImage index={i} />
			{:else if brief.type == 3}
			<FieldDate index={i} />
			{/if}
			{/each}

			<p>
				<ButtonAddElement />	
			</p>

			<hr>

			<div class="field">
				<label class="label has-text-white">Output PDF Name</label>
				<div class="control">
					<input class="input has-text-white has-background-dark" type="text" placeholder="Text input" bind:value={$outputFileName}>
				</div>
			</div>
			<br>
			<div class="buttons is-right">
				<button class="button is-success is-light" on:click={() => previewHandler()}>Preview</button>
			</div>
		</div>
	</section>

	<footer class="footer has-background-black has-text-white">
		<div class="content has-text-centered">
			<p>
				Brief Burger 2021 by Affan Abiyyu
			</p>
		</div>
	</footer>
</main>
{#if $modalIsActive}
<ModalPreview />
{/if}